// "IN" -> "🇮🇳", "us" -> "🇺🇸"
export function countryCodeToFlag(code: string): string {
  if (!code || code.length !== 2) return "🏳️"; // fallback
  const cc = code.toUpperCase();
  const A = 0x41; // 'A'
  const REGIONAL = 0x1f1e6; // regional indicator 'A'
  return String.fromCodePoint(
    REGIONAL + (cc.charCodeAt(0) - A),
    REGIONAL + (cc.charCodeAt(1) - A)
  );
}
